import {
  TokenErrorCodes,
  HttpStatus,
  CODE_TIMEOUT,
  UNKNOWN_ERROR,
} from './const';
import goMaintenancePage from '../helpers/goMaintenancePage';

/**
 * Handle error from api
 * @param error error from response
 * @param requestTimes number of request times
 * @param requestTimesLimit limit of request times
 */
export default (error, requestTimes, requestTimesLimit) => {
  let errorRes;

  if (!error || !error.status || error.status !== HttpStatus.OK) {
    console.error(JSON.parse(JSON.stringify(error)));
    goMaintenancePage();
    errorRes = {
      code: UNKNOWN_ERROR,
      message: UNKNOWN_ERROR,
    };
    return errorRes;
  }

  if (error.code === CODE_TIMEOUT) {
    if (requestTimes === requestTimesLimit - 1) {
      goMaintenancePage();
    }
    errorRes = {
      code: CODE_TIMEOUT,
      message: 'Api timeout',
    };
    return errorRes;
  }

  if (TokenErrorCodes.includes(error.data.code)) {
    // not used yet in this project
    goMaintenancePage();
  } else {
    // not used yet in this project
    goMaintenancePage();
  }

  errorRes = {
    code: error.data.code,
    message: error.data.message,
  };
  return errorRes;
};
